import moment from 'moment';
import 'moment-timezone';

// Основной часовой пояс приложения
export const TZ = 'Asia/Qyzylorda';

export const nowTz = () => moment.tz(TZ);

export const startOfDayTz = (d) => moment.tz(d, TZ).startOf('day');

export const endOfDayTz = (d) => moment.tz(d, TZ).endOf('day');

export const toYMD = (d) => moment.tz(d, TZ).format('YYYY-MM-DD');


